import { Link } from "react-router-dom";
import { CoverageRing, LivenessDot } from "../glyphs";
import Instant from "./Instant";
import StatusBadge from "./StatusBadge";
import type { Run } from "../types";

function Pill({ run }: { run: Run }) {
  return (
    <Link
      to={`/runs/${run.id}`}
      className="flex shrink-0 items-center gap-3 rounded-lg bg-base-200 px-3 py-2 hover:bg-base-300"
    >
      <LivenessDot liveness={run.liveness} />
      <span className="font-semibold">#{run.run_number}</span>
      <span className="text-sm opacity-70">{run.scope_kind.replaceAll("_", " ")}</span>
      <StatusBadge status={run.status} />
      <CoverageRing pct={run.coverage_pct} size={30} />
      <span className="text-xs opacity-60 whitespace-nowrap">
        <Instant iso={run.created_at} />
      </span>
    </Link>
  );
}

/** In-flight runs as compact pills; the pulse is the signal, the rest is context. */
export default function LivePills({ runs }: { runs: Run[] }) {
  if (runs.length === 0) {
    return <p className="text-sm opacity-60">Nothing running right now.</p>;
  }
  return (
    <div className="flex gap-2 overflow-x-auto pb-1">
      {runs.map((run) => (
        <Pill key={run.id} run={run} />
      ))}
    </div>
  );
}
